"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AverageTimeframeForFulfillingOrderReason = void 0;
const Field_type_1 = require("../../../types/Field.type");
exports.AverageTimeframeForFulfillingOrderReason = {
    priority: Number.MAX_VALUE,
    label: 'fields.payload.mor_entity_answers.average_timeframe_for_fulfilling_order_reason.label',
    fallbackLabel: 'Please specify the average time frame and provide the reason for why the offered products are subject to an extended timeframe from order captured until delivered.',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['mor_entity_answers.average_timeframe_for_fulfilling_order', 'contract_onboarding_type'],
    type: Field_type_1.FieldType.String,
    trackFieldValueWithAnalytics: false,
};
function isMandatory(payload, path) {
    return payload.mor_entity_answers?.average_timeframe_for_fulfilling_order?.valueOf?.() === 'ABOVE_SEVEN'
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_ENTITY');
}
function isApplicable(payload, path) {
    return payload.mor_entity_answers?.average_timeframe_for_fulfilling_order?.valueOf?.() === 'ABOVE_SEVEN'
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_ENTITY');
}
